import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const PopTrigger = styled('button', {
  all: 'unset',
  textDecoration: 'underline',
  textDecorationStyle: 'dotted',
  textUnderlineOffset: '2px',
  cursor: 'pointer',
  color: '$primary-500',

  variants: {
    color: {
      black: { color: '$accent-black' },
    },
  },
})

export const PopoverCard = styled('div', {
  backgroundColor: '$accent-white',
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: '0 4px 24px rgba(0,0,0,0.12)',
  padding: '$2',
  display: 'flex',
  flexDirection: 'column',
  gap: '$1',
  width: '200px',

  '@mobile': {
    width: '280px',
  },

  '@bp1': {
    width: '320px',
  },

  '@bp2': {
    width: '384px',
  },
})

export const PopoverCardHeader = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  marginRight: '-6px',
})

export const PopoverCardClose = styled('button', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'none',
  border: 'none',
  padding: '2px',
  cursor: 'pointer',
  color: '$accent-black',
  borderRadius: '4px',
  '&:hover': {
    color: '$tertiary-800',
  },
  '&:focus': {
    outline: 'none',
  },
})

export const PopoverCardImage = styled('div', {
  position: 'relative',
  width: '100%',
  borderRadius: '8px',
  overflow: 'hidden',

  variants: {
    variant: {
      liveBetter: {
        aspectRatio: '352/160',
      },
      realResults: {
        aspectRatio: '292/160',
      },
    },
  },
})

export const PopoverCardBody = styled('div', {
  padding: '$1 0 0',
  display: 'flex',
  flexDirection: 'column',
  gap: '$1',
})

export const PopoverCardHeading = styled(Text, {
  fontSize: '$body',
  letterSpacing: '$label',
  lineHeight: '$label',
})

export const PopoverCardText = styled(Text, {
  fontSize: '$small',
  lineHeight: '$small',
  color: '$tertiary-800',
})
